import React from 'react';
import { RadioStyled } from '../../asset/styled/component/RadioStyled';

const Radio = ({
  label,
  name = '',
  size,
  value = '',
  checked,
  onChange = () => {},
  disabled = false,
  style = {},
}) => {
  const fontSize =
    size === 'large' ? 'body1Regular' : size === 'small' ? 'captionMedium' : 'body2Medium';

  return (
    <RadioStyled size={size} checked={checked} disabled={disabled}>
      <label style={style}>
        <input
          type="radio"
          name={name}
          value={value}
          className="hiddenRadio"
          checked={checked}
          onChange={onChange}
        />
        <div className="showRadio">
          <div className="showRadioInner"></div>
        </div>
        <span className={fontSize}>{label}</span>
      </label>
    </RadioStyled>
  );
};

export default Radio;
